import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../context/SiteContext';

/**
 * Simple static content page for nav/footer links that don't need a full feature module.
 */
const InfoPage = ({ title, children }) => {
  const { siteName } = useSite();

  return (
    <article className="info-page" style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px 80px' }}>
      <nav style={{ fontSize: 14, marginBottom: 24, color: '#666' }}>
        <Link to="/" style={{ color: '#0066cc', textDecoration: 'none' }}>
          Home
        </Link>
        <span style={{ margin: '0 8px' }}>/</span>
        <span>{title}</span>
      </nav>
      <h1 style={{ fontSize: 28, marginBottom: 16, fontWeight: 700 }}>{title}</h1>
      <div style={{ color: '#444', lineHeight: 1.65, fontSize: 16 }}>{children}</div>
      <p style={{ marginTop: 32 }}>
        <Link to="/shop" style={{ color: '#e21a2c', fontWeight: 600, textDecoration: 'none' }}>
          Shop all products
        </Link>
        <span style={{ margin: '0 12px', color: '#ccc' }}>|</span>
        <Link to="/contact" style={{ color: '#0066cc', textDecoration: 'none' }}>
          Contact {siteName}
        </Link>
      </p>
    </article>
  );
};

export default InfoPage;
